/**
 * Table Colors CSS Generator
 *
 * Function for generating complete CSS from table colors attributes using responsive utilities
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import { RESPONSIVE_BREAKPOINTS } from '@redfox-thank-you/control-groups';

import type { TableColorsAttributes } from '../types';
import { generateTableColorsCSSRules } from './rules';

/**
 * Generate complete responsive CSS for table colors control group
 */
export const getTableColorsCSS = (
	attributes: TableColorsAttributes,
	blockSelector: string = '',
): string => {
	let css = '';

	// Generate styles for each breakpoint
	( [ 'desktop', 'tablet', 'mobile' ] as const ).forEach( ( breakpoint ) => {
		const values = attributes[ breakpoint ];

		if ( ! values ) return;

		const rules = generateTableColorsCSSRules( values, blockSelector );

		if ( Object.keys( rules ).length === 0 ) return;

		// Convert rules to CSS format
		const cssRules = Object.entries( rules )
			.map( ( [ selector, rule ] ) => `${ selector } { ${ rule }; }` )
			.join( '\n' );

		if ( breakpoint === 'desktop' ) {
			// Desktop styles without media query
			css += `${ cssRules }\n\n`;
		} else {
			// Tablet and mobile with media queries
			const maxWidth = RESPONSIVE_BREAKPOINTS[ breakpoint ];
			css += `@media (max-width: ${ maxWidth }) {\n`;
			css += cssRules.replace( /^/gm, '  ' ); // Add indentation
			css += '\n}\n\n';
		}
	} );

	return css.trim();
};

// Re-export the rules function for direct access
export { generateTableColorsCSSRules } from './rules';
